<template>
  <el-collapse v-model="activeCollapses" class="collapse-main-content" style="margin-top: 16px">
    <!-- <el-card style="margin-top: 16px">
    <div slot="header" class="title">
      <span>审批信息</span>
    </div> -->
    <el-collapse-item name="1">
      <template slot="title">
        <div class="collapse-title-pre">
          <span></span>
          审批信息
        </div>
      </template>
      <div class="collapse-content">
        <sirui-table
          ref="siruiTable"
          :data="auditRecordData"
          :paging="false"
          :setting="false"
          :customVisible="false"
          :columns="searchColumn"
        >
          <!-- <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column> -->
          <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
          <vxe-table-column
            v-for="(item, index) in searchColumn"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :field="item.field"
            :title="item.title ? $t(item.title) : null"
            :visible="item.visible"
            :type="item.type"
            :width="item.width"
            :height="100"
          >
            <template v-slot="{ row }">
              <template v-if="item.field == 'fileList'">
                <span
                  v-for="(item1, index) in row[item.field]"
                  :key="index"
                  @click="uploadFile(row, index)"
                >
                  <span style="color: #009fcc">{{ item1.attachmentName }}</span
                  >&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
              </template>
              <template v-else>{{ row[item.field] }}</template>
            </template>
          </vxe-table-column>
        </sirui-table>
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
  export default {
    name: 'auditRecord',
    props: ['detailAuditRecords'],
    data() {
      return {
        activeCollapses: ['1'],
        auditRecordData: [],
        searchColumn: [
          {
            field: 'optUserName',
            title: '操作人',
            visible: true,
          },
          {
            field: 'optType',
            title: '操作',
            visible: true,
          },
          {
            field: 'optTime',
            title: '操作时间',
            visible: true,
          },
          {
            field: 'info',
            title: '审批信息',
            visible: true,
          },
          {
            field: 'fileList',
            title: '附件',
            visible: true,
            height: 100,
          },
        ],
      };
    },
    watch: {
      detailAuditRecords(newVal) {
        if (newVal) {
          this.dealData(newVal);
        }
      },
    },
    methods: {
      dealData(list) {
        console.log(list, 'listlist');
        this.auditRecordData = list;
      },
      getName(val) {
        console.log('val--', val);
      },
      uploadFile(row, index) {
        console.log(row, index);
        window.open(row.fileList[index].attachmentPath, '_blank');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .title {
    font-size: 20px;
    font-weight: 600;
  }
</style>
